import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const markerPosition = {
	position: 'absolute',
	transform: 'translate(-50%, -50%)',
};

const MarkerPoint = (props) => {
	const { id, isActive, onClick } = props;

	const handleClick = React.useCallback(() => {
		if (onClick) {
			onClick({ id });
		}
	}, [id, onClick]);

	return (
		<div
			tabIndex={0}
			role="button"
			aria-label="marker"
			onClick={handleClick}
			className={cn('MarkerPoint', { MarkerPoint_active: isActive })}
			style={markerPosition}
		/>
	);
};

MarkerPoint.propTypes = {
	id: PropTypes.number,
	isActive: PropTypes.bool,
	onClick: PropTypes.func,
};

MarkerPoint.defaultProps = {
	id: undefined,
	onClick: undefined,
	isActive: false,
};

export default MarkerPoint;
